<template>
  <div class="rob-otoole slide">
    <HorizontalAnimation :animation="animation" :loop="true" />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">API &amp; Law Enforcement</p>
      <h1>Rob O'Toole</h1>
      <p>Investigators receive a hit on the pickup’s tags that identify the registered owner as <strong>Rob O’Toole</strong>. A secondary search reveals that O’Toole shares an address with Cruella DeWalt, who was previously apprehended at store 1763.</p>
    </div>
    <router-link to="/case-update">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import RobOToole from '@/assets/rob-otoole.js'

export default {
  name: 'rob-otoole',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: RobOToole
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">

</style>
